import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(unsafe: string | null, context: SecurityContext): string | SafeResourceUrl | null {
    if (!unsafe) {
      return null;
    }

    switch (context) {
      case SecurityContext.STYLE:
        return this.sanitizer.sanitize(SecurityContext.STYLE, `url(${unsafe})`);
      case SecurityContext.RESOURCE_URL:
        return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64,${unsafe}`);
      case SecurityContext.HTML:
        return this.sanitizer.bypassSecurityTrustHtml(unsafe);
      default:
        return null;
    }
  }
}
